import {mapState} from 'vuex'
import FormatService from '../../../services/format-service'

export default {
    name: 'OrderHistory',
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        ...mapState({
            orders: state => state.account.orders,
            user: state => state.account.user
        }),
    },
    created() {
        this.$store.dispatch('account/getOrderHistory');
    },
    filters: {
        euro(value) {
            return FormatService.euro(value)
        }
    }
}